<div *ngIf="categories | async as categoriesList">
  <div *ngFor="let category of categoriesList" data-dgat="hmm-tag-picker-78c">
    <dgx-tag-dropdown
      [skills]="category.detailedSkills"
      [sectionTitle]="category.name"
      (toggleSkill)="onToggleTag($event, categoriesList)"
      class="block guts-m-v-2"
      data-dgat="hmm-tag-picker-8cc"
    ></dgx-tag-dropdown>
  </div>
</div>
<div *ngIf="isLoading">
  <div class="spinner"></div>
</div>
